import { useSelector } from "react-redux";
import { useRef, useState, useEffect } from "react";
import textContentSmarthomeContactUsSection from "../../smarthome/ui/textContent-smarthome-contactUsSection";

export default function ProductCard(props) {
  const { title, subtitle, image, productURL, isActive } = { ...props };
  const language = useSelector((state) => state.dictionary.language);
  const isMobile = useSelector((state) => state.screen.isMobile);

  return (
    <div
      className={`product ${isActive ? "active" : ""} ${isMobile ? "mobile" : ""}`}
    >
      <img src={image} aria-hidden="true" />
      <h3 className="h3-bold h3-product">{title}</h3>
      <h4 className="h4-product">{subtitle}</h4>
      <a href={productURL} className="learn-more-button-outline">
        {textContentSmarthomeContactUsSection.learnMoreSection.title[language]}
      </a>
    </div>
  );
}
